/**************************************************
 * Nombre:       Dialogo_Marcas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarFechaAct} from "../../Servicios/BD/Actualizadores/guardarFechaAct";
import Formulario_Marcas from "../Formularios/Formulario_Marcas";

const Dialogo_Marcas = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')

        await guardarFechaAct('marcas')
        let dox = await guardarDoc('marcas', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('marcas', datos.id)
        terminar({aviso: 'Marca borrada'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Marcas props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Marcas